import React from "react"
import Allskills from "../constants/Allskills"
// import { Link } from "gatsby"

import Title from "./Title"

const Skills = ({ title, showLink }) => {
  return (
    <section className="section">
      <Title title={title} />
      <Allskills />

      {/* {showLink && (
        <Link to="/skills" className="btn center-btn">
          all my skills{" "}
        </Link>
      )} */}
    </section>
  )
}
export default Skills
